import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 nlp_transform"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>TekRevol’s Progressive Web App Development Process</h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              The development process of PWAs is a crucial part, as we make use
              of agile methodologies to carefully craft the application tailored
              to your preferences.
            </p>
            <p>
              The process aims to create an application that is focused on
              fulfilling user needs and is adaptable to the evolving
              requirements of your business as well.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Discovery and Requirement Analysis</h5>
                <p>
                  The process kicks off with an initial foray into requirements
                  as the TekRevol team interacts with clients to understand
                  their business objectives, target market, and needs. This
                  includes extensive and quite detailed market research, a
                  staunch competitive analysis, and a clear understanding of
                  user behavior to shape a PWA that aligns perfectly with the
                  client's idea.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Design and User Experience (UX)</h5>
                <p>
                  As the requirements are communicated, the design phase begins.
                  TekRevol aims to create a user-centric design that offers
                  reflexive navigation and an engaging user experience
                  altogether. Next, we develop wireframes and prototypes to
                  visualize the app's layout and functionality. The design
                  process ensures that the PWA is appealing to the eyes and also
                  optimized for performance across different devices and sizes
                  of the screen.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Technology Stack Selection</h5>
                <p>
                  TekRevol ensures a suitable technology stack by adopting
                  frameworks like Angular, React, or Vue.js for the front end in
                  conjunction with strong backend solutions. Technologies are
                  chosen based on project needs, achieving scalability,
                  security, and performance. Service workers, a core feature of
                  PWAs, are implemented for offline capabilities and push
                  notifications.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Development and Iteration</h5>
                <p>
                  The design is brought to life in the development stage.
                  TekRevol's progressive web app developers follow Agile
                  methodologies that are flexible and adaptive. PWA development
                  focuses on speed, reliability, and responsiveness. The
                  iterative process allows for regular feedback and further
                  refinement of the end product to meet the highest quality
                  standards.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>Quality Assurance through Testing</h5>
                <p>
                  Rigorous testing is the backbone of TekRevol's PWA development
                  process. The PWA goes through various testing phases,
                  including functionality, usability, performance, and security.
                  TekRevol ensures that the app operates perfectly across
                  different browsers and devices, maintaining consistent user
                  experiences. Identified bugs or issues are promptly addressed
                  to ensure the app's integrity.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Deployment and Launch</h5>
                <p>
                  After successful testing, the PWA is deployed to the
                  production environment. TekRevol ensures that the deployment
                  process occurs smoothly with minimal downtime. The app is
                  launched with all necessary configurations, and the team
                  monitors its performance to ensure it meets its intended
                  goals.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-md-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                07
              </div>
              <div className="rapid_content">
                <h5>Maintenance and Support</h5>
                <p>
                  Post-launch, TekRevol provides continuous support and
                  maintenance to keep the PWA updated and functional. This
                  includes updates, strict monitoring of performance, and prompt
                  improvements based on user feedback only. TekRevol's
                  commitment to excellence ensures that PWAs continue to evolve
                  with changing business requirements and technological
                  advancements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                08
              </div>
              <div className="rapid_content">
                <h5>Continuous Improvement</h5>
                <p>
                  The journey of PWA development at TekRevol continues after
                  deployment. The analysis of the Application, scrutiny of user
                  engagement, and reviews on market trends, all lead to the
                  introduction of new features and improvements. This commitment
                  to continuous improvement benefits businesses by helping them
                  stay competitive and adapt to the evolving needs of users.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
